import { EntityListItemConverter } from './EntityListItemConverter';
import { EntityListSkuQuantityInputData } from '../entityListTypes';
import { ImportedItemRow } from '../../../../../lib/imports/importTypes';
import { isDigitsOnly } from '@ydistri/generic-utils';

/**
 * Converts data containing store, product, and quantity information to/from a structured format.
 */
export class EntityListSkuQuantityItemConverter extends EntityListItemConverter<EntityListSkuQuantityInputData> {
  convertFromStrings(cells: string[]): Partial<EntityListSkuQuantityInputData> {
    const result: Partial<EntityListSkuQuantityInputData> = {};

    cells.forEach((cell, index) => {
      switch (index) {
        case 0:
          result.product = cell;
          break;
        case 1:
          result.store = cell;
          break;
        case 2:
          result.count = 0;
          if (cell.length > 0 && isDigitsOnly(cell)) {
            const tmpValue = parseInt(cell);
            if (!isNaN(tmpValue)) {
              result.count = tmpValue;
            }
          }
          break;
      }
    });

    return result;
  }

  convertToStructuredText(data: ImportedItemRow<EntityListSkuQuantityInputData>[]): string {
    const validParsedRowsFlat = data
      .map(row => `${row.inputData.product},${row.inputData.store},${row.inputData.count}`)
      .join('\n');
    return `ProductIdentification,StoreIdentification,Quantity\n${validParsedRowsFlat}`;
  }
}
